<template>
    <div :class="wrapperClass">

        <div v-show="inActiveText"
             :class="inActiveClass">
           <span>{{inActiveText}}</span>
        </div>
        <div :class="counterClass">
          <span> {{currentValue}} / </span> <span class="total">{{totalValue}}</span>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'counter',
        props: {
            currentValue: {
                type: Number,
                default: 0,
            },
            totalValue: {
                type: Number,
                default: 0,
            },
            inActiveText: {
                type: String,
                default: null
            },
            inActiveClass: {
                type: String,
                default: ''
            },
            wrapperClass: {
                type: String,
                default: ''
            },
            counterClass: {
                type: String,
                default: ''
            },

        },
        data() {
            return {}
        },
        methods: {},
        created() {


        }
    }
</script>
<style lang="scss" scoped>

</style>